import React, { forwardRef, useImperativeHandle, useRef } from "react"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import DynamicFormField from "./DynamicFormField"
import { autoFillData } from "@common/FunctionList"
import { useNavigate } from "react-router"

const VehicleDetails = forwardRef((props: any, ref) => {
    const [sectionItem, setSectionItem] = useState<any>({})
    const insuranceState = useSelector((state: any) => state.insurance)
    const commonState = useSelector((state: any) => state.common)
    const hasAutoFilledRef = useRef(false)

    const navigate = useNavigate()

    const applyEditModeFieldLocks = (sectionData: any) => {
        if (!props?.isEditMode || !sectionData?.blocks?.length) return sectionData

        return {
            ...sectionData,
            blocks: sectionData.blocks.map((block: any) => ({
                ...block,
                fields: (block.fields || []).map((field: any) =>
                    field.name === 'insurance_type' ? { ...field, is_enable: false } : field
                )
            }))
        }
    }

    const applyClassificationOptions = (sectionData: any) => {
        if (!sectionData?.blocks?.length) return sectionData

        const vehicleMapping = commonState?.common?.vehicle_classification_mapping || []
        const updatedBlocks = sectionData.blocks.map((block: any) => {
            const fields = [...(block.fields || [])]
            const vehicleTypeField = fields.find((f: any) => f.name === 'vehicle_classification')
            const vehicleTypeId = vehicleTypeField?.value?.value
            if (!vehicleTypeId) return block

            const mapOptions = (fieldName: string) => {
                const list = commonState?.common?.[fieldName] || []
                const allowed = new Set(
                    vehicleMapping
                        .filter((m: any) => m.vehicle_type === vehicleTypeId)
                        .map((m: any) => fieldName === 'classification_id' ? m.classification_id : m.commercial_type)
                        .filter((v: any) => v !== null && v !== undefined)
                )
                return list.filter((item: any) => allowed.has(item.value))
            }

            return {
                ...block,
                fields: fields.map((field: any) => {
                    if (!['classification_id', 'commercial_type'].includes(field.name)) return field

                    const options = mapOptions(field.name)
                    const rawValue = typeof field.value === 'object' ? field.value?.value : field.value
                    const matched = options.find((opt: any) => +opt.value === +rawValue)
                    return {
                        ...field,
                        options,
                        value: matched || (rawValue !== undefined && rawValue !== null && rawValue !== ''
                            ? { label: String(rawValue), value: +rawValue }
                            : field.value)
                    }
                })
            }
        })

        return applyEditModeFieldLocks({ ...sectionData, blocks: updatedBlocks })
    }

    const autoFillVehicleDetails = async (insuranceData: any) => {
        // Prefer lead details; fall back to createInsurance MMV saved during edit load
        const createInsurance = insuranceState?.createInsurance || {}
        const mergedData = {
            ...createInsurance,
            ...insuranceData,
            make_name: insuranceData?.make_name || createInsurance?.make_name,
            model_name: insuranceData?.model_name || createInsurance?.model_name,
            version_name: insuranceData?.version_name || createInsurance?.version_name,
            make: insuranceData?.make ?? createInsurance?.make,
            model: insuranceData?.model ?? createInsurance?.model,
            version: insuranceData?.version ?? createInsurance?.version,
            classification_id: insuranceData?.classification_id ?? createInsurance?.classification_id,
            commercial_type: insuranceData?.commercial_type ?? insuranceData?.commercial_type_id ?? createInsurance?.commercial_type,
            vehicle_type: insuranceData?.vehicle_type ?? createInsurance?.vehicle_type,
            vehicle_usage: insuranceData?.vehicle_usage ?? createInsurance?.vehicle_usage,
        }
        const updatedData = await autoFillData(mergedData, insuranceState?.formConfig?.[1])
        setSectionItem(applyClassificationOptions(updatedData))
        hasAutoFilledRef.current = true
    }

    useImperativeHandle(ref, () => ({
        getData: () => {
            return { vehicle_details: [...sectionItem?.blocks?.[0]?.fields], customer_details: [...sectionItem?.blocks?.[1]?.fields] }
        }
    }))

    useEffect(() => {
        if (!insuranceState?.formConfig?.length) return

        const insuranceData = (props?.resubmissionLeadId || props?.isEditMode)
            ? insuranceState.resubmissionLeadData
            : insuranceState?.insuranceData

        const hasLeadData = insuranceData && Object.keys(insuranceData)?.length && !insuranceData?.autoFillVehicleDetails
        const hasEditMmvFallback = props?.isEditMode && (
            insuranceState?.createInsurance?.make_name || insuranceState?.createInsurance?.classification_id
        )

        // Avoid resetting a completed autofill when formConfig reference changes
        if (hasAutoFilledRef.current) return

        if (hasLeadData) {
            autoFillVehicleDetails(insuranceData)
        } else if (hasEditMmvFallback) {
            autoFillVehicleDetails(insuranceState.createInsurance)
        } else {
            setSectionItem(applyEditModeFieldLocks(JSON.parse(JSON.stringify(insuranceState?.formConfig?.[1]))));
        }
        // eslint-disable-next-line
    }, [insuranceState.insuranceData, insuranceState?.formConfig, insuranceState?.resubmissionLeadData, props?.isEditMode, props?.resubmissionLeadId])

    useEffect(() => {
        if (!(props?.documents && Object.keys(props?.documents)?.length) && !props?.resubmissionLeadId && !props?.isEditMode) {
            props?.setPage(1)
            navigate('/create-insurance-policy?step=upload_document')
        }
        //eslint-disable-next-line
    }, [props?.documents])

    return (
        <div className="loan-filed-sec">
            <div className="form-group-bx vehchile-detail-form">
                <div className="row">
                    {
                        sectionItem?.blocks?.map((blockItem: any, index: number) =>
                            <React.Fragment key={index}>
                                <div className="col-md-12 col-xs-12">
                                    <div className="summery-heading">
                                        <h2>{blockItem.title}</h2>
                                    </div>
                                </div>
                                <DynamicFormField
                                    fields={blockItem?.fields}
                                    stateCityList={props.stateCityList}
                                    fetchCustomerData={() => { }}
                                    setLoading={props.setLoading}
                                    SetUpdateMakeYear={props.SetUpdateMakeYear}
                                />
                            </React.Fragment>
                        )
                    }

                </div>
            </div>
        </div>
    )
})

export default VehicleDetails
